import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import TransactionType from "@homegame/common/dist/enum/transaction-type.enum";
import { capitalize } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";

const useStyles = makeStyles(() =>
  createStyles({
    formControl: {
      maxWidth: "40%",
      marginRight: 10,
      "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgba(255,255,255,.5)",
      },
    },
    select: {},
    label: {
      top: -7,
      fontSize: 13,
      "&.Mui-focused": {
        color: "rgba(255,255,255,.7)",
        textShadow: "none",
        top: 2,
        left: 3,
      },
    },
    checkbox: {
      "& .MuiSvgIcon-root": { fill: "rgba(255,255,255,.7)" },
    },
    input: {
      borderColor: "rgba(255,255,255,.5)",
      "& .MuiSelect-select": {
        padding: "4px 35px 5px 15px",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgba(255,255,255,.5)",
        borderRadius: 15,
      },
    },
  }),
);

export default function SelectTypeComponent({
  selectedType,
  onChange,
}: {
  onChange: (t: TransactionType[]) => void;
  selectedType: TransactionType[];
}) {
  const classes = useStyles({});
  const transactionTypes = Object.values(TransactionType);

  const getTypeName = (type: TransactionType) => {
    if (type === TransactionType.GAME_OFFSET) return "Game offset";
    if (type === TransactionType.DEBT_TRANSFER) return "Debt transfer";
    return capitalize(type);
  };

  const handleChangeType = (event: SelectChangeEvent<TransactionType[]>) => {
    const {
      target: { value },
    } = event;
    onChange(value as TransactionType[]);
  };

  return (
    <FormControl fullWidth className={classes.formControl}>
      <InputLabel className={classes.label}>Type</InputLabel>
      <Select
        autoWidth
        multiple
        value={selectedType}
        onChange={handleChangeType}
        input={<OutlinedInput label="Type" className={classes.input} />}
        renderValue={(selected) =>
          Object.values(selected)
            .map((s) => getTypeName(s))
            .join(", ")
        }
      >
        {transactionTypes.map((type) => (
          <MenuItem key={type} value={type}>
            <Checkbox
              checked={selectedType.includes(type)}
              className={classes.checkbox}
            />
            <ListItemText primary={getTypeName(type)} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
